var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentPair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.401 3.268 C 4.205 3.338,3.999 3.484,3.867 3.646 C 3.821 3.702,3.524 4.101,3.208 4.532 C 2.732 5.181,2.621 5.354,2.566 5.533 C 2.500 5.747,2.499 5.823,2.508 11.500 L 2.517 17.250 2.607 17.442 C 2.715 17.674,2.992 17.959,3.205 18.058 C 3.291 18.098,3.456 18.146,3.572 18.165 C 3.864 18.213,16.136 18.213,16.428 18.165 C 16.544 18.146,16.709 18.098,16.795 18.058 C 17.008 17.959,17.285 17.674,17.393 17.442 L 17.483 17.250 17.492 11.500 C 17.501 5.856,17.500 5.746,17.435 5.533 C 17.379 5.348,17.275 5.190,16.708 4.433 C 16.344 3.947,15.988 3.506,15.917 3.452 C 15.846 3.399,15.705 3.320,15.603 3.278 L 15.417 3.202 10.000 3.202 C 4.703 3.202,4.579 3.204,4.401 3.268 M15.464 4.875 C 15.656 5.118,15.826 5.335,15.844 5.358 C 15.869 5.392,14.695 5.400,10.001 5.400 C 6.256 5.400,4.132 5.388,4.139 5.368 C 4.145 5.350,4.308 5.133,4.500 4.885 L 4.850 4.434 9.983 4.434 L 15.117 4.434 15.464 4.875 M6.667 7.550 L 6.667 8.467 10.000 8.467 L 13.333 8.467 13.333 7.550 L 13.333 6.633 14.783 6.633 L 16.233 6.633 16.233 11.783 L 16.233 16.933 10.000 16.933 L 3.767 16.933 3.767 11.783 L 3.767 6.633 5.217 6.633 L 6.667 6.633 6.667 7.550 ",
    fill: "#727A82",
    stroke: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentPair);
export default __webpack_public_path__ + "static/media/equipment-pair.80331d88d9c8f983567b03d7710e4d19.svg";
export { ForwardRef as ReactComponent };